export default {
  namespaced: true,

  state: {
    installAppFn: false,
  },

  getters: {
    installable: state => !!state.installAppFn,
  },

  actions: {
    install({ state }) { state.installAppFn && state.installAppFn() },
  },

  mutations: {
    SET_FN(state, fn) { state.installAppFn = fn },
  },
}
